import { ReactNode } from "react";
import { ReactComponent as PhoneIcon } from "../assets/icons/phone.svg";
import { ReactComponent as MailIcon } from "../assets/icons/mail.svg";
import { ReactComponent as InstagramIcon } from "../assets/icons/instagram.svg";
import { ReactComponent as FacebookIcon } from "../assets/icons/facebook.svg";
import Label from "./Label";
import "../stylesheets/form.scss";
import { Link } from "react-router";

// TYPES

type FormProps = {
	title: string;
	description: string;
	children?: ReactNode;
};

// COMPONENT

function Form({ title, description, children }: FormProps) {
	return (
		<div className="labeled-form">
			<div>
				<h2>{title}</h2>
				<p className="primary-text">{description}</p>
				<div className="icons">
					<Label icon={<PhoneIcon />} title="07 69 54 87 12" />
					<Label icon={<MailIcon />} title="LEPETITBAR76@GMAIL.COM" />
					<div>
						<Link to="https://www.instagram.com/lepetitbarcocktails/?hl=fr">
							<InstagramIcon />
						</Link>
						<Link to="https://www.facebook.com/LePetitBarCocktails/?locale=fr_FR">
							<FacebookIcon />
						</Link>
					</div>
				</div>
			</div>
			{children}
		</div>
	);
}

export default Form;
